import React from 'react';
import { BasicContainer, ContainerFull } from '../../UI/ContentContainer';
import TextContent from '../../UI/TextContent';
import PageTitle from '../../UI/PageTitle';
import { Box, Container, Typography } from '@mui/material';
import { BoxCard, ImageNumberList, JobResponse } from '../../UI/List/List';
import born from '../../../assets/img/born_gray.png';
import process from '../../../assets/img/skeleton_page/process.png';
import SupportContent from '../../UI/SupportContent';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import MetaTags from '../../MetaTags/MetaTags';

const range = [
    '하루에 4시간 이상 집중적으로 자료입력 등을 위해 키보드 또는 마우스를 조작하는 작업',
    '하루에 총 2시간 이상 목, 어깨, 팔꿈치, 손목 또는 손을 사용하여 같은 동작을 반복하는 작업',
    '하루에 총 2시간 이상 머리 위에 손이 있거나, 팔꿈치가 어깨 위에 있거나, 팔꿈치를 몸통으로부터 들거나, 팔꿈치를 몸통 뒤쪽에 위치하도록 하는 상태에서 이루어지는 작업',
    '지지되지 않은 상태이거나 임의로 자세를 바꿀 수 없는 조건에서, 하루에 총 2시간 이상 목이나 허리를 구부리거나 트는 상태에서 이루어지는 작업',
    '하루에 총 2시간 이상 쪼그리고 앉거나 무릎을 굽힌 자세에서 이루어지는 작업',
    '하루에 총 2시간 이상 지지되지 않은 상태에서 1kg 이상의 물건을 한손의 손가락으로 집어 옮기거나, 2kg 이상에 상응하는 힘을 가하여 한손의 손가락으로 물건을 쥐는 작업',
    '하루에 총 2시간 이상 지지되지 않은 상태에서 4.5kg 이상의 물건을 한 손으로 들거나 동일한 힘으로 쥐는 작업',
    '하루에 10회 이상 25kg 이상의 물체를 드는 작업',
    '하루에 25회 이상 10kg 이상의 물체를 무릎 아래에서 들거나, 어깨 위에서 들거나, 팔을 뻗은 상태에서 드는 작업',
    '하루에 총 2시간 이상, 분당 2회 이상 4.5kg 이상의 물체를 드는 작업',
    '하루에 총 2시간 이상 시간당 10회 이상 손 또는 무릎을 사용하여 반복적으로 충격을 가하는 작업'
];

const work = [
    '근골격계 유해요인조사 실시계획서 작성',
    '근골격계부담작업 및 유해요인조사 교육(필요 시)',
    '근골격계 유해요인조사를 위한 사전조사',
    '근골격계질환 증상집계 및 분석',
    '공정/작업별 유해요인조사표 작성',
    '작업환경 개선계획서 작성',
    '기타 협의하여 결정된 사항',
];



const SkeletonPage = () => {
    return (
        <BasicContainer>
            <MetaTags
                title="근골격계유해요인조사"
                description="근골격계유해요인조사에 대해 소개 합니다."
                ogtitle="드림산업안전센터(주)-근골격계유해요인조사"
                ogdescription="근골격계유해요인조사에 대해 소개 합니다."
            />
            <PageTitle title="근골격계유해요인조사"/>
            <TextContent title="근골격계유해요인조사란?" data-aos="fade-up">
                <Typography variant="description" component="p">산업안전보건법 제39조, 산업안전보건기준에 관한 규칙 제12장에 의거 단순반복작업 또는 인체에 과도한 부담을 주는 작업으로 인한 건강장해를 예방하기 위하여 근골격계 유해요인조사를 실시하여야 합니다.</Typography>
            </TextContent>

            <TextContent title="실시시기">
                <BoxCard 
                    data-aos="fade-left"
                    title="최초평가" 
                    description={['- 신설일부터 1년 이내 최초 유해요인조사 실시']}
                />
                <BoxCard 
                    data-aos="fade-left"
                    title="정기평가" 
                    description={[
                        '- 유해요인조사 결과 근골격계부담작업을 하는 경우 매 3년마다 실시',
                        '- 수시평가'
                    ]}
                />
                <BoxCard 
                    data-aos="fade-left"
                    title="수시평가" 
                    description={[
                        '- 법에 따른 임시건강진단 등에서 근골격계질환자가 발생하였거나 근로자가 근골격계질환으로 업무상 질병으로 인정받은 경우',
                        '- 근골격계부담작업에 해당하는 새로운 작업·설비를 도입한 경우',
                        '- 근골격계부담작업에 해당하는 업무의 양과 작업공정 등 작업환경을 변경한 경우',
                    ]}
                />
            </TextContent>

            <TextContent title="근골격계부담작업 범위" data-aos="fade-up">
                <Typography variant="description" component="p">
                    산업안전보건법 제24조 제1항 제5호 및 산업안전보건기준에 관한 
                    규칙 제 656조 제 1호에 따른 근골격계부담작업이란 다음 각 호의 
                    어느 하나에 해당하는 작업을 말한다. 다만, 단기간 작업 또는 간헐적인 
                    작업은 제외한다.
                </Typography>
                <Typography variant="reference" component="p" marginTop="1rem">
                    단기작업은 2개월 이내에 종료하는 작업을 말하며, 
                    간헐적인 작업은 정기적, 부정기적으로 이루어지는 
                    작업으로써 연간 총 작업시간이 60일을 초과하지 않는 작업을 말함
                </Typography>
                <ImageNumberList 
                    data={range} 
                    image={born}
                    alt="born.png"
                    marginTop="2rem"
                />
            </TextContent>

            <TextContent title="근골격계 유해요인조사 절차" data-aos="fade-up">
                <Box textAlign='center' paddingTop='2rem'>
                    <img src={process} alt="process.png" style={{width: '100%', maxWidth: '739px'}}/>
                </Box>
            </TextContent>  

            <ContainerFull>
                <Container maxWidth="md">
                    <Typography variant="subTitle" component="h2" textAlign='center'>
                        업무 내용
                    </Typography>
                    <Grid container spacing={2}>
                        {work.map((item, index) => (
                            <Grid key={index} xs={12}>
                                <JobResponse title={item} data-aos="fade-left"/>
                            </Grid>
                        ))}
                        
                    </Grid>
                </Container>
            </ContainerFull>


            {/* <SupportContent 
                title="수행업무"
                data={work}
                aos="fade-left"
            /> */}
        </BasicContainer>
    )
}

export default SkeletonPage;